// src/styles/globalStyles.js
import { createGlobalStyle } from 'styled-components';
import { typography } from './typography';

export const GlobalStyles = createGlobalStyle`
  :root {
    --primary-color: ${({ theme }) => theme.primaryColor};
    --secondary-color: ${({ theme }) => theme.secondaryColor};
    --text-color: ${({ theme }) => theme.textColor};
    --background-color: ${({ theme }) => theme.backgroundColor};
    --font-family: ${({ theme }) => theme.fontFamily};
    --border-radius: ${({ theme }) => theme.borderRadius};
    --padding: ${({ theme }) => theme.padding};
    --margin: ${({ theme }) => theme.margin};
    --heading-font-size: ${({ theme }) => theme.headingFontSize || '2rem'};
    --text-font-size: ${({ theme }) => theme.textFontSize || '1rem'};
  }

  body {
    margin: 0;
    padding: 0;
    text-align: left;
  }

  label {
    text-align: left;
    display: block;
    margin-bottom: 4px;
    font-weight: 500;
  }

  .hide-on-desktop {
    display: none;
  }
  
  .auth-card {
    width: 100%;
    max-width: 420px;
    margin: auto;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box; /* ✅ Prevents padding from causing overflow */
    overflow-x: hidden;     /* ✅ Prevents scroll spill */
  }

  ${typography}
  
 /* ✅ Mobile-friendly data-labels inside table cells */
  @media (max-width: 768px) {

    .hide-on-mobile {
      display: none !important;
    }

    .hide-on-desktop {
      display: block !important;
    }

    td[data-label] {
      display: block;
      width: 100%;
      padding: 8px 0;
    }

    td[data-label]::before {
      content: attr(data-label) ": ";
      font-weight: bold;
      display: block;
      color: #555;
      margin-bottom: 4px;
    }

    tr {
      display: block;
      margin-bottom: 12px;
      border-bottom: 1px solid #eee;
    }

    thead {
      display: none;
    }

    table {
      width: 100%;
    }
  }
`;

export default GlobalStyles;